<template>
    <b-form-row>
        <b-modal @hidden="handleClear" size="xl" button-size="sm" :id="this.id" ref="finder" hide-footer
            :title="prefix + title">
            <PessoaList :precisaExistirUsuario="precisaExistirUsuario" v-if="!isComissao"
                @onDblClickPessoa="pessoaSelect" :prefix="prefix" />

            <ComissaoList v-else @comissaoSelect="comissaoSelect" :prefix="prefix + title" />
        </b-modal>
        <lg-form-input-finder v-model="computedValue" :fieldDescription="isComissao ? 'descricao' : 'nome'"
            :label="isComissao ? labelComissao : label" :showClear='!disabled'
            invalidFeedback="Pessoa deve ser informada!" description="" @handleClean="pessoaSelect"
            :disabled="disabled">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" :disabled="disabled" pressed>
                    <b-icon icon="search" />
                </b-button>

            </template>

            <template #comissao>
                <b-button id="idComissao" v-if="mostrarComissao" style="height: 20px;  " @click="mudar"
                    class="btn-input-finder" :disabled="disabled" pressed>
                    <b-icon :icon="isComissao ? 'person-fill' : 'people-fill'" />
                    <b-tooltip :title="isComissao ? 'Alterar para Pessoa' : 'Alterar para Comissão'"
                        target="idComissao"></b-tooltip>

                </b-button>

            </template>

        </lg-form-input-finder>

    </b-form-row>
</template>
<script>
import LgFormInputFinder from '@/core/components/Form/LgFormInputFinder.vue'

import ComissaoList from '@/modules/cadastros/comissao/ComissaoList.vue';

export default {

    components: {
        LgFormInputFinder,
        PessoaList: () => import("@/modules/cadastros/pessoa/PessoaList.vue"),
        ComissaoList
    },

    props: {
        precisaExistirUsuario: {
            type: Boolean,
            default: false,
        },

        mostrarComissao: {
            type: Boolean,
            default: false
        },

        comecaComissao: {
            type: Boolean,
            default: false
        },

        id: String,
        value: [Object, String],
        cols: String,
        prefix: {
            type: String,
            default: "",
        },
        title: {
            type: String,
            default: "Pessoa",
        },
        label: {
            type: String,
            default: "Pessoa:",
        },
        labelComissao: {
            type: String,
            default: "Comissão:",
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        error: {
            type: Object,
            default: null,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            isComissao: this.comecaComissao,
            nome: "",
            localValue: this.value,
            pessoa: "",
            fields: [
                {
                    key: "action",
                    label: " ",
                    thClass: "pt-1 pb-0",
                    tdClass: "py-0 text-center col-1",
                },
            ],
        }
    },
    computed: {
        computedValue: {
            get() {
                return this.localValue
            },
            set(newValue) {
                this.localValue = newValue
                this.$emit("input", newValue)
            },
        },
    },
    methods: {
        mudar() {

            if (this.isComissao)
                this.$emit("onselectComissao", {})

            else
                this.$emit("onselect", {})

            this.isComissao = !this.isComissao;

        },
        async show() {
            await this.$refs.finder.show()
        },
        updateValue(newValue) {
            this.computedValue = newValue
            this.$emit("onselect", newValue)
        },
        async handleClear() {
            this.$emit("onClear", {})
            await this.$bvModal.hide(this.id)

        },
        async pessoaSelect(item) {
            this.computedValue = item
            this.$emit("onselect", item)
            this.$emit("change")
            await this.$bvModal.hide(this.id)
        },

        async comissaoSelect(item) {
            this.computedValue = item
            this.$emit("onselectComissao", item)
            await this.$bvModal.hide(this.id)
        },
    },
    watch: {
        value(newValue) {
            this.localValue = newValue
        }
    }
}
</script>
